import { useMemo } from 'react';
import { useGetProfileQuery } from '@/features/onboarding/api';
import { calculateDailyIntake } from '@/features/settings/utils/dailyIntake';

export function useRecipesWithPersonalizedNutrition(recipes) {
  const { data: profileData } = useGetProfileQuery();
  const profile = profileData?.data?.profile;
  const nutritionProfile = profile?.nutrition_profile;
  const dailyIntake = useMemo(() => calculateDailyIntake(nutritionProfile), [nutritionProfile]);

  const recipesWithNutrition = useMemo(() => {
    if (!recipes?.data?.data) return [];

    return recipes.data.data.map(recipe => {
      let personalizedNutrition = null;
      
      if (recipe && recipe.servings && recipe.nutrition) {
        const perServing = {
          kcal: Math.round(recipe.nutrition.kcal / recipe.servings),
          protein: Math.round(recipe.nutrition.protein / recipe.servings * 10) / 10,
          fat: Math.round(recipe.nutrition.fat / recipe.servings * 10) / 10,
          carbs: Math.round(recipe.nutrition.carbs / recipe.servings * 10) / 10,
        };

        const caloriesPercentage = (perServing.kcal / dailyIntake.kcal) * 100;
        const proteinPercentage = (perServing.protein / dailyIntake.protein) * 100;
        const fatPercentage = (perServing.fat / dailyIntake.fat) * 100;
        const carbsPercentage = (perServing.carbs / dailyIntake.carbs) * 100;

        personalizedNutrition = {
          perServing,
          caloriesPercentage,
          proteinPercentage,
          fatPercentage,
          carbsPercentage,
        };
      }

      return {
        ...recipe,
        personalizedNutrition,
      };
    });
  }, [recipes, dailyIntake]);

  return recipesWithNutrition;
}

